export const iconFontAwesomeWeatherTemperatureLow = (
	<i className="fa-solid fa-temperature-low"></i>
);
